





import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FieldTextSizeItem extends Vue {
  @Prop() size!: number;
  @Prop() selected: boolean;

  handleSelect() {
    this.$emit('select', this.size);
  }
}
